import { render } from "./localLogin.vue?vue&type=template&id=2be1361e&scoped=true"
import script from "./localLogin.vue?vue&type=script&lang=js"
export * from "./localLogin.vue?vue&type=script&lang=js"

import "./localLogin.vue?vue&type=style&index=0&id=2be1361e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be1361e"]])

export default __exports__